import { Map as immutableMap } from 'immutable';
import { getField, updateField } from 'vuex-map-fields';
import objectValue from '@/utils/objectValue';

const STATE = immutableMap({
  date: Date.now(),
  itemsConnectors: {},
});

export const state = () => STATE.toJS();

export const getters = {
  getField,
};

export const mutations = {
  reset(state) {
    Object.assign(state, {
      ...STATE.toJS(),
      date: Date.now(),
    });
  },
  updateField,
};

export const actions = {
  /**
   * Set connectors
   */
  async setConnectors(context) {
    const items = context.rootState.nodes.items;
    if (!Array.isArray(items)) {
      return false;
    }
    let temp = {};

    const setConnector = item => {
      const from = objectValue(item, 'from');
      const id = objectValue(item, 'id');

      const blockA = document.querySelector(`[data-connector-from=${from}]`);
      const blockB = document.querySelector(`[data-connector-to=${id}]`);

      if (!blockA || !blockB) {
        return;
      }

      const area = document.querySelector('.b-connectors-area');
      const areaX = area.getBoundingClientRect().left;
      const areaY = area.getBoundingClientRect().top;

      const aX = (blockA.getBoundingClientRect().left + blockA.getBoundingClientRect().width) - areaX;
      const aY = (blockA.getBoundingClientRect().top + blockA.getBoundingClientRect().height / 2) - areaY;
      const bX = blockB.getBoundingClientRect().left - areaX;
      const bY = (blockB.getBoundingClientRect().top + blockB.getBoundingClientRect().height / 2) - areaY;

      const connectorParams = {
        aX,
        aY,
        bX,
        bY,
      };

      temp[from] = {
        id,
        from,
        returnToParent: item.returnToParent,
        connectorParams,
      };
    };

    for (const item of items) {
      setConnector(item);
    }

    context.commit('updateField', {
      path: 'itemsConnectors',
      value: temp,
    });

    return true;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
